/** 收发通双语名称只用于展示；单语和同名只显示一次。 */
export function formatContactBilingualName(nameCn?: unknown, nameEn?: unknown): string {
  const names = [nameCn, nameEn].map(value => String(value ?? '').trim()).filter(Boolean)
  return [...new Set(names)].join(' / ')
}

/** 公司原值仍用于保存和匹配；只有已匹配名称才补充另一语种，手填原文不被替换。 */
export function formatContactCompanyName(record: {
  company?: unknown
  companyNameCn?: unknown
  companyNameEn?: unknown
}): string {
  const company = String(record.company ?? '').trim()
  if (!company) return ''
  const names = [record.companyNameCn, record.companyNameEn].map(value => String(value ?? '').trim())
  return names.includes(company) ? formatContactBilingualName(names[0], names[1]) : company
}

/** 兼容国家选择器的主数据和历史回显结构，不改变国家 ID。 */
export function formatContactCountryOptionLabel(item: Record<string, any>): string {
  const country = item.content || item
  return formatContactBilingualName(
    item.nameCn || country.countryNameCn || country.nameCn,
    item.nameEn || country.countryNameEn || country.nameEn
  ) || String(item.label || item.code || country.countryCode || item.value || item.id || '')
}
